import {useEffect, useRef} from "react"

export const useInterval = (callback, delay) => {
  const intervalRef = useRef(null)
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const tick = () => savedCallback.current()
    if (!isNaN(delay) && isFinite(delay)) {
      intervalRef.current = window.setInterval(tick, delay)
      return () => window.clearInterval(intervalRef.current)
    }
  }, [delay])
  return intervalRef
}



// WEBPACK FOOTER //
// ./src/hooks/useInterval.js